import {useSelector} from "react-redux";
import {selectFieldValue} from "state/selectors/data";

const nullObj = {};

export function useEdges(id) {
    return useSelector(s=>selectFieldValue(s, 'db.nodes', id, 'edges_ref')) || nullObj;
}